import React from "react";
import PropTypes from "prop-types";

const Header = ({ title, subtitle = null }) => {
  return (
    <header className="w-full place-content-center h-32 md:h-36 lg:h-40 bg-gray-100 py-6 text-blue-900">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-lg font-medium text-gray-600">{subtitle}</p>
        )}
      </div>
    </header>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default Header;
